/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { UserSignInStep } from './enums';
import { Encrypt } from './base.models';

export class UserSignInRequest {
	public _step: UserSignInStep;
	@Encrypt()
	public password: string;
	public name: string;
	public email: string;

	constructor(values: UserSignInRequest) {
		for (const [key, value] of Object.entries(values)) this[key] = value;
	}
}
